import { FileElement, ProjectFileType } from "@xlabmedical/medic-api";

type ProjectFileLike = Pick<FileElement, "name"> & {
    type?: ProjectFileType | string;
};

const projectMobilePreviewSuffix = ".zip.mobile.json";

export function isProjectMobilePreviewFile(file?: ProjectFileLike | null) {
    return file?.type === ProjectFileType.Mobile || (file?.type === ProjectFileType.ProjectAttachmentPreview && file.name?.endsWith(projectMobilePreviewSuffix));
}

export function shouldIgnoreProjectFileEvent(file: ProjectFileLike) {
    if (file.type === "stl_preview" || file.type === ProjectFileType.ProcessingData) {
        return true;
    }

    return file.type === ProjectFileType.ProjectAttachmentPreview && !isProjectMobilePreviewFile(file);
}

export function resolveMobileFile<T extends ProjectFileLike>(eventFile: T) {
    if (isProjectMobilePreviewFile(eventFile)) {
        return eventFile;
    }

    return undefined;
}
